import React from 'react';
import { FaSearch, FaBarcode, FaFileInvoice } from 'react-icons/fa';

const PricingFilters = ({
  // Invoice filter
  invoices,
  selectedInvoiceId,
  handleInvoiceFilter,
  invoiceLoading,
  invoiceEANs,
  // Scanner
  scannerInputRef,
  barcodeInput,
  setBarcodeInput,
  handleBarcodeInput,
  handlePasteBarcodes,
  scannerFilterActive,
  setScannerFilterActive,
  scannedBarcodes,
  handleClearAllBarcodes,
  handleAddScannedToBuffer,
  handleRemoveBarcode,
  allProducts,
  // Text filter
  filterTerm,
  setFilterTerm,
  // Checkbox "Dostepne": zaznaczony (domyslnie) = lista tylko ze stanem, tak jak
  // dotad. Odznaczony = dociagamy takze produkty bez stanu, zeby wyszukiwarka
  // znajdowala wyprzedane karty (o to prosil wlasciciel 04.09).
  pokazBezStanu,
  setPokazBezStanu,
  ladowanieProduktow,
  // Category / Manufacturer filter
  categories,
  selectedCategory,
  setSelectedCategory,
  manufacturers,
  selectedManufacturer,
  setSelectedManufacturer,
  // Price type filter
  advancedFilters,
  setAdvancedFilters,
  // Selection
  handleSelectAll,
  setSelectedProducts,
  // Pagination reset
  setCurrentPage,
  // Filtered products count
  filteredProductsCount,
}) => {
  return (
    <div style={{ padding: "0.75rem", borderBottom: "1px solid var(--border)", backgroundColor: "var(--bg)" }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', alignItems: 'center' }}>
        {/* FILTR PO FAKTURZE ZAKUPOWEJ */}
        <select
          style={{
            padding: '6px 10px',
            border: selectedInvoiceId ? '2px solid var(--info)' : '1px solid var(--border)',
            borderRadius: '6px',
            fontSize: '12px',
            minWidth: '200px',
            backgroundColor: selectedInvoiceId ? 'var(--info-light)' : 'var(--card-bg)' ,
            fontWeight: selectedInvoiceId ? '600' : 'normal'
          }}
          value={selectedInvoiceId || ''}
          onChange={(e) => handleInvoiceFilter(e.target.value ? parseInt(e.target.value) : null)}
        >
          <option value="">{'📋'} Wszystkie produkty</option>
          {Array.isArray(invoices) && invoices.map(inv => (
            <option key={inv.id} value={inv.id}>
              {'📄'} {inv.numer_faktury} ({inv.dostawca_nazwa})
            </option>
          ))}
        </select>
        {selectedInvoiceId && (
          <button
            style={{ padding: '4px 10px', fontSize: '11px', border: '1px solid var(--text-muted)', color: 'var(--text-muted)' }}
            onClick={() => handleInvoiceFilter(null)}
            title="Wyczyść filtr faktury"
          >
            {'✕'}
          </button>
        )}
        {invoiceLoading && <span style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{'⏳'}</span>}

        {/* SKANER KODÓW KRESKOWYCH */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          padding: '2px',
          border: scannerFilterActive ? '2px solid var(--cyan)' : '1px solid var(--cyan)',
          borderRadius: '4px',
          backgroundColor: scannerFilterActive ? 'var(--cyan-light)' : 'var(--card-bg)'
        }}>
          <FaBarcode style={{ fontSize: '14px', color: 'var(--info)', marginLeft: '4px' }} />
          <input
            ref={scannerInputRef}
            type="text"
            value={barcodeInput}
            onChange={(e) => setBarcodeInput(e.target.value)}
            onKeyDown={handleBarcodeInput}
            onPaste={handlePasteBarcodes}
            placeholder="Skanuj kod..."
            style={{
              width: '120px',
              padding: '4px 8px',
              borderRadius: '3px',
              fontSize: '12px',
              fontFamily: 'monospace',
              backgroundColor: 'transparent',
              outline: 'none'
            }}
          />
          {scannedBarcodes.length > 0 && (
            <span style={{
              border: '1px solid var(--info)', color: 'var(--info)' ,
              padding: '2px 6px',
              borderRadius: '10px',
              fontSize: '10px',
              fontWeight: '600'
            }}>
              {scannedBarcodes.length}
            </span>
          )}
        </div>

        {/* Pokaż/ukryj tylko zeskanowane */}
        {scannedBarcodes.length > 0 && (
          <>
            <button
              style={{
                padding: '4px 10px',
                fontSize: '11px',
                border: '1px solid var(--info)',
                cursor: 'pointer',
                backgroundColor: scannerFilterActive ? 'var(--info-light)' : 'var(--card-bg)',
                color: 'var(--info)',
                fontWeight: scannerFilterActive ? '700' : '500'
              }}
              onClick={() => {
                setScannerFilterActive(!scannerFilterActive);
                setCurrentPage(1);
              }}
              title={scannerFilterActive ? 'Pokaż wszystkie produkty' : 'Pokaż tylko zeskanowane'}
            >
              {scannerFilterActive ? '👁️ Tylko skan' : '📋 Filtruj'}
            </button>
            <button
              style={{
                padding: '4px 10px',
                fontSize: '11px',
                border: '1px solid var(--danger)',
                cursor: 'pointer',
                backgroundColor: 'var(--card-bg)',
                color: 'var(--danger)'
              }}
              onClick={handleClearAllBarcodes}
              title="Wyczyść zeskanowane kody"
            >
              {'✕'}
            </button>
          </>
        )}

        {/* Wyszukiwarka */}
        <div style={{ flex: '1 1 200px', minWidth: '150px', position: 'relative' }}>
          <FaSearch style={{ position: 'absolute', left: '0.5rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)', fontSize: '11px' }} />
          <input type="text" style={{ width: '100%', padding: '6px 10px 6px 1.75rem', border: '1px solid var(--border)', borderRadius: '6px', fontSize: '12px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
            placeholder="Szukaj produktu..." value={filterTerm} onChange={(e) => { setFilterTerm(e.target.value); setCurrentPage(1); }} />
        </div>
        {/* Dostepne: odznaczenie dociaga produkty bez stanu (wolniejsze, wiecej wierszy) */}
        <label
          title={pokazBezStanu
            ? 'Lista zawiera takze produkty bez stanu magazynowego'
            : 'Zaznaczone: tylko produkty ze stanem. Odznacz, zeby szukac takze wsrod niedostepnych'}
          style={{
            display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', cursor: 'pointer',
            padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px',
            backgroundColor: pokazBezStanu ? 'var(--warning-light)' : 'var(--card-bg)',
            color: pokazBezStanu ? 'var(--warning)' : 'var(--text)', whiteSpace: 'nowrap'
          }}>
          <input type="checkbox" checked={!pokazBezStanu} disabled={!!ladowanieProduktow}
            onChange={(e) => { setPokazBezStanu(!e.target.checked); setCurrentPage(1); }}
            style={{ width: '14px', height: '14px', cursor: 'pointer' }} />
          {ladowanieProduktow ? 'Wczytuje...' : 'Dostepne'}
        </label>
        {/* Kategorie */}
        <select style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', fontSize: '12px', minWidth: '130px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
          value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
          <option value="">Wszystkie kategorie</option>
          {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
        </select>
        {/* Producent */}
        <select style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', fontSize: '12px', minWidth: '130px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
          value={selectedManufacturer} onChange={(e) => setSelectedManufacturer(e.target.value)}>
          <option value="">Wszyscy producenci</option>
          {manufacturers.map(m => <option key={m.id} value={m.id}>{m.nazwa}</option>)}
        </select>
        {/* Typ ceny */}
        <select style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', fontSize: '12px', color: 'var(--text)', backgroundColor: advancedFilters.priceType !== 'all' ? 'var(--info-light)' : 'var(--card-bg)' }}
          value={advancedFilters.priceType} onChange={(e) => setAdvancedFilters(prev => ({ ...prev, priceType: e.target.value }))}>
          <option value="all">Wszystkie ceny</option>
          <option value="special">Specjalne</option>
          <option value="default">Ceny specjalne do uzupełnienia</option>
        </select>
        {/* Zakres marzy od-do (%) - filtruje po tej samej marzy co kolumna w tabeli */}
        {(() => {
          const marginActive = advancedFilters.marginMin !== '' || advancedFilters.marginMax !== '';
          const inputStyle = {
            width: '52px', padding: '6px 8px', border: '1px solid var(--border)',
            borderRadius: '6px', fontSize: '12px', backgroundColor: 'var(--card-bg)', color: 'var(--text)'
          };
          return (
            <div style={{
              display: 'flex', alignItems: 'center', gap: '0.3rem',
              padding: '0 0.4rem', border: marginActive ? '2px solid var(--info)' : '1px solid var(--border)',
              borderRadius: '6px', backgroundColor: marginActive ? 'var(--info-light)' : 'var(--card-bg)',
              height: '32px'
            }}>
              <span style={{ fontSize: '11px', fontWeight: marginActive ? '600' : 'normal', whiteSpace: 'nowrap' }}>Marża</span>
              <input type="number" step="0.1" placeholder="od" title="Marża od (%)" style={inputStyle}
                value={advancedFilters.marginMin}
                onChange={(e) => setAdvancedFilters(prev => ({ ...prev, marginMin: e.target.value }))} />
              <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>–</span>
              <input type="number" step="0.1" placeholder="do" title="Marża do (%)" style={inputStyle}
                value={advancedFilters.marginMax}
                onChange={(e) => setAdvancedFilters(prev => ({ ...prev, marginMax: e.target.value }))} />
              <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>%</span>
              {marginActive && (
                <button title="Wyczyść filtr marży"
                  style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '11px', color: 'var(--danger)', padding: '0 0.15rem' }}
                  onClick={() => setAdvancedFilters(prev => ({ ...prev, marginMin: '', marginMax: '' }))}>✕</button>
              )}
            </div>
          );
        })()}
        {/* Zaznacz/Odznacz */}
        <button style={{ padding: '4px 10px', fontSize: '11px', fontWeight: '500', border: '1px solid var(--success)', color: 'var(--success)' }} onClick={handleSelectAll}>{'✓'} Zaznacz</button>
        <button style={{ padding: '4px 10px', fontSize: '11px', fontWeight: '500', border: '1px solid var(--danger)', color: 'var(--danger)' }} onClick={() => setSelectedProducts(new Set())}>{'✕'} Odznacz</button>
      </div>

      {/* Info o filtrze faktury */}
      {selectedInvoiceId && invoiceEANs.size > 0 && (
        <div style={{ marginTop: '0.5rem', padding: '0.4rem 0.6rem', background: 'var(--info-light)', borderRadius: '4px', fontSize: '10px', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <FaFileInvoice />
          <span><strong>Filtr faktury aktywny:</strong> {filteredProductsCount} produktów z {invoiceEANs.size} pozycji faktury{filteredProductsCount < invoiceEANs.size ? ` · ${invoiceEANs.size - filteredProductsCount} pozycji nie ma w kartotece tej lokalizacji` : ''}</span>
        </div>
      )}

      {/* PASEK ZESKANOWANYCH PRODUKTÓW */}
      {scannedBarcodes.length > 0 && (
        <div style={{
          marginTop: '0.5rem',
          padding: '0.5rem',
          background: 'linear-gradient(135deg, var(--cyan-light), var(--info-light))',
          borderRadius: '4px',
          border: '1px solid var(--cyan)'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '0.5rem'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FaBarcode style={{ color: 'var(--info)' }} />
              <span style={{ fontSize: '11px', fontWeight: '600', color: 'var(--info)' }}>
                Zeskanowane produkty: {scannedBarcodes.length}
              </span>
              <span style={{ fontSize: '10px', color: 'var(--text-muted)' }}>
                (znaleziono: {scannedBarcodes.filter(code =>
                  allProducts.some(p =>
                    p.ean?.trim().toLowerCase() === code.toLowerCase() ||
                    p.kod_produktu?.trim().toLowerCase() === code.toLowerCase()
                  )
                ).length})
              </span>
            </div>
            <div style={{ display: 'flex', gap: '4px' }}>
              <button
                onClick={handleAddScannedToBuffer}
                style={{
                  padding: '4px 10px',
                  fontSize: '11px',
                  border: '1px solid var(--success)', color: 'var(--success)' ,
                  cursor: 'pointer'
                }}
              >
                {'📋'} Do bufora
              </button>
              <button
                onClick={handleClearAllBarcodes}
                style={{
                  padding: '4px 10px',
                  fontSize: '11px',
                  backgroundColor: 'var(--card-bg)',
                  color: 'var(--danger)',
                  border: '1px solid var(--danger)',
                  cursor: 'pointer'
                }}
              >
                {'🗑️'} Wyczyść
              </button>
            </div>
          </div>

          {/* Lista zeskanowanych kodów */}
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
            maxHeight: '80px',
            overflowY: 'auto'
          }}>
            {scannedBarcodes.map((code, idx) => {
              const product = allProducts.find(p =>
                p.ean?.trim().toLowerCase() === code.toLowerCase() ||
                p.kod_produktu?.trim().toLowerCase() === code.toLowerCase()
              );
              const isFound = !!product;

              return (
                <div
                  key={code}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    padding: '2px 6px',
                    backgroundColor: isFound ? 'var(--success-light)' : 'var(--warning-light)',
                    border: `1px solid ${isFound ? 'var(--success)' : 'var(--warning)'}`,
                    borderRadius: '12px',
                    fontSize: '9px'
                  }}
                  title={isFound ? product.nazwa : 'Nie znaleziono produktu'}
                >
                  <span style={{ fontWeight: '600' }}>{idx + 1}.</span>
                  <span style={{ fontFamily: 'monospace' }}>{code}</span>
                  {isFound && (
                    <span style={{ color: 'var(--success)', maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {product.nazwa?.substring(0, 20)}...
                    </span>
                  )}
                  <button
                    onClick={() => handleRemoveBarcode(code)}
                    style={{
                      padding: '0 3px',
                      backgroundColor: 'transparent',
                      color: 'var(--danger)',
                      
                      cursor: 'pointer',
                      fontSize: '10px',
                      lineHeight: 1
                    }}
                  >
                    {'✕'}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingFilters;
